//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/** @jsxImportSource @emotion/react */

export const scrollbarStyles = {
  scrollableContainer: {
    // For Firefox
    scrollbarWidth: 'thin' as const,
    scrollbarColor: 'rgba(168, 168, 189, 0.5) transparent',

    // Apply padding to prevent content from being cut off
    paddingBottom: '160px',
  },

  globalStyles: `
    .ai-module-scrollable::-webkit-scrollbar,
    .MuiMenu-list::-webkit-scrollbar {
      width: 2px;
      height: auto;
    }
    
    .ai-module-scrollable::-webkit-scrollbar-track,
    .MuiMenu-list::-webkit-scrollbar-track {
      background: transparent;
      margin: 2px;
      margin-bottom: 140px; /* Keep track clear near the input area */
    }
    
    .ai-module-scrollable::-webkit-scrollbar-thumb,
    .MuiMenu-list::-webkit-scrollbar-thumb {
      background-color: rgba(211, 211, 211, 0.5);
      border-radius: 10px;
      border: 0px solid transparent;
      background-clip: content-box;
    }
    
    .ai-module-scrollable::-webkit-scrollbar-thumb:hover,
    .MuiMenu-list::-webkit-scrollbar-thumb:hover {
      background-color: rgba(180, 180, 180, 0.7);
    }
    
    /* Fix for zoomed browsers */
    @media screen and (min-resolution: 0dppx) {
      .ai-module-scrollable {
        padding-bottom: 160px !important;
      }
      
      .ai-module-scrollable::-webkit-scrollbar-track {
        margin-bottom: 200px;
      }
    }
  `,
};

export default scrollbarStyles;
